import React, { FC } from 'react';
import { SubHeader } from '../../../components/sub-header/SubHeader';
import { SubHeaderRails } from '../../../components/sub-header/SubHeaderRails';
import { EnterpriseActionSlider } from './EnterpriseActionSlider';

type Props = {
  isVisible: boolean;
};

export const EnterpriseSubHeader: FC<Props> = ({ isVisible }) => {
  return (
    <SubHeader classNames="hide_on--mobile" id="enterprise-sub-header">
      <SubHeaderRails>
        <EnterpriseActionSlider isVisible={isVisible} />
      </SubHeaderRails>
    </SubHeader>
  );
};
